import React, { useEffect } from "react";
import PaymentDetail from "../components/PaymentDetail";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaymentData } from "../../redux/slices/paymentSlice";
import { updateCustomerDetail } from "../../redux/slices/customerSlice";
import ErrorTransactionNotFound from "../components/ErrorTransactionNotFound";
import Loading from "../../components/LoadingCustom";
import { isExpiredError, createErrorNavigationState } from "../../utils/paymentLinkErrorHandler";
import { getExpiredRedirectUrl, redirectToMerchantUrl } from "../utils/paymentLinkRedirects";

const isTruthyFlag = (value) => [true, 1, "1", "true"].includes(value);

const FirstForm = () => {
  if(process.env.REACT_APP_DEBUG){
    console.log('ini env: ',process.env.REACT_APP_API_URL);
  }

  const { reffNo } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uneditable = searchParams.get("uneditable") === "1";

  useEffect(() => {
    const name = searchParams.get("name");
    let phone = searchParams.get("phone");
    const email = searchParams.get("email");
    const address = searchParams.get("address");
    const city = searchParams.get("city");
    const state = searchParams.get("state");
    const postalCode = searchParams.get("postal_code");

    if (phone) {
      phone = phone.replace(/^\+62/, "0");
      if (phone.startsWith("62") && !phone.startsWith("0")) {
        phone = "0" + phone.substring(2);
      }
    }

    if (name || phone || email || address || city || state || postalCode) {
      dispatch(updateCustomerDetail({
        ...(name && { fullName: name }),
        ...(phone && { phone }),
        ...(email && { email }),
        ...(address && { address }),
        ...(city && { city }),
        ...(state && { state }),
        ...(postalCode && { postalCode }),
      }));
    }
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  // Mengambil state dari Redux store, including errorCode
  const {
    data: paymentData,
    isLoading,
    error,
    errorCode,
    errorPaymentData,
  } = useSelector((state) => state.payment);

  useEffect(() => {
    if (reffNo) {
      dispatch(fetchPaymentData(reffNo));
    }
  }, [dispatch, reffNo]);

  // Handle navigation based on error code
  useEffect(() => {
    if (error && errorCode) {
      // If payment link is expired, navigate to expired page
      if (isExpiredError(errorCode)) {
        const expiredRedirectUrl = getExpiredRedirectUrl(errorPaymentData || paymentData);

        if (redirectToMerchantUrl(expiredRedirectUrl)) {
          return;
        }

        navigate('/payment-expired', {
          replace: true,
          state: createErrorNavigationState(
            { errorCode, message: error },
            {
              reffNo,
              redirectUrl: expiredRedirectUrl,
            }
          ),
        });
      }
      // For other errors, show generic not found page (handled by return below)
    }
  }, [error, errorCode, errorPaymentData, navigate, paymentData, reffNo]);

  const requiresCustomerDetail = paymentData
    ? isTruthyFlag(paymentData.required_customer_detail)
    : false;

  const shouldSkipCustomerDetailForm = paymentData
    ? !requiresCustomerDetail
    : false;

  useEffect(() => {
    if (paymentData && shouldSkipCustomerDetailForm) {
      navigate(`/method/${paymentData.reff_no}`, { replace: true });
    }
  }, [paymentData, shouldSkipCustomerDetailForm, navigate]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-gray-200 bg-opacity-50 flex justify-center items-center z-50">
        <Loading />
      </div>
    );
  }

  if (error || !paymentData) {
    return <ErrorTransactionNotFound errorCode={errorCode} message={error} />;
  }

  if (shouldSkipCustomerDetailForm) {
    return null;
  }

  return (
    <PaymentDetail
      merchant_name={paymentData.account.merchant.name}
      account_name={paymentData.account.name}
      title={paymentData.title}
      total_amount={paymentData.total_amount}
      reffNo={paymentData.reff_no}
      include_constumer_detail={paymentData.required_customer_detail}
      required_customer_fields={paymentData.required_customer_fields}
      status={paymentData.status}
      payment_url={paymentData.payment_url}
      description={`Pembayaran untuk order ${paymentData.reff_no}`}
      items={paymentData.items || []}
      uneditable={uneditable}
      isMultiplePayment={paymentData.is_multiple_payment}
      maxUsage={paymentData.max_usage}
      emailRequired={paymentData.require_customer_email}
      nameRequired={paymentData.require_customer_name}
      phoneRequired={paymentData.require_customer_phone}
    />
  );
};

export default FirstForm;
